
export const searchKeys = ['fadoelsType', 'description', 'name', 'regularName', 'productPageDescription', 'productPageXtraDescription', 'descriptionXtra', 'keywords', 'popupDescription'];
export const ignoreWords = ['til', 'for', 'og', 'af', 'fra', '.', ',', '-', '_', 'drik', 'på', 'med', 'varenr', 'varenummer'];
